import { Text } from "@chakra-ui/react";

import packageJson from "../../package.json";
import { environmentDisplayName } from "../config";

const capitalizedEnvironmentDisplayName = environmentDisplayName
  ?  environmentDisplayName.charAt(0).toUpperCase() + environmentDisplayName.slice(1)
  : "";

const isProduction = !capitalizedEnvironmentDisplayName || capitalizedEnvironmentDisplayName === "Production";

export function VersionTag() {
  const version = packageJson.version.replace(/(\.0)*$/, ""); // remove trailing zero version-segments

  return (
    <Text
      color="brand.gray.120"
      fontSize="xs"
      id="version-tag"
      textAlign="right"
    >
      Versie {version}
      {!isProduction && ` - ${capitalizedEnvironmentDisplayName}`}
    </Text>
  );
}
